/** 「もっと見る」一覧に遷移できるセクション。さがす画面とおすすめ画面で共有する */
export const DISCOVER_SEE_MORE_SECTIONS = [
  "instant_call",
  "preference_match",
  "high_review",
  "ranking",
  "sadistic",
  "masochistic",
  "footprint",
] as const;

export type DiscoverSeeMoreSection =
  (typeof DISCOVER_SEE_MORE_SECTIONS)[number];
